import styled from 'styled-components';

import promoColors from 'theme/promoColors';

import fonts from '../../../../../theme/fonts';
import promoMedia from '../../../../../theme/promoMedia';

export const ModalHeader = styled.div`
    margin-bottom: 24px;
    text-align: center;

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
    }
`;
export const IconWrapper = styled.figure`
    height: 80px;
    margin: 0 auto 24px;
    width: 80px;
`;
export const DataSent = styled.div`
    text-align: center;
`;

export const HubSpotForm = styled.div`
    .hs-form {
        .hs-form-field {
            padding: 0px;
            margin-bottom: 20px;
            font-family: ${fonts.regular};
            .hs-input {
                font-family: ${fonts.regular};
                color: ${promoColors.gray40};
                padding: 12px;
                border: 1px solid ${promoColors.gray20};
                background: ${promoColors.white};
                border-radius: 8px;
                display: flex;
                flex-direction: row;
                align-items: center;
                cursor: pointer;
                height: 55px;
                font-size: 17px;
                line-height: 24px;
                ${promoMedia.desktop1440} {
                    font-size: 20px;
                    line-height: 32px;
                }
            }
            .hs-input:not(:placeholder-shown) {
                color: ${promoColors.baseColor};
            }

            .submitted-message {
                text-align: center;
                color: ${promoColors.primary};
            }

            .hs-form-booleancheckbox a {
                color: ${promoColors.primary};
                font-family: ${fonts.regular};
            }
        }
        .hs_error_rollup ul li {
            text-align: center;
        }
        .hs-submit {
            display: flex;
            justify-content: center;
        }
        .hs-button {
            font-family: ${fonts.regular};
            font-size: 17px;
            border-radius: 56px;
            width: auto;
            padding: 12px 30px;
            margin-top: 20px;
            background: ${promoColors.primary};
            color: ${promoColors.white};
        }
        .hs-button:hover {
            cursor: pointer;
            background: ${promoColors.purple20};
        }
        .hs-error-msgs {
            font-family: ${fonts.regular};
            color: ${promoColors.error};
            font-size: 14px;
        }
    }
`;
